import React, { useState, useEffect } from 'react';
import Grid from '@mui/material/Grid2';

import { 
  Character, 
  Language, 
  CharacterSheetInterface,
} from "@dndModels";

import DandDCharacterUtilities from "@dndUtilities/char_utilities";

import StringBox from "@components/input/strings/StringBox";
import SelectStringBox from "@components/input/selects/SelectStringBox";

interface Props {
  character: Character;
  char_interface: CharacterSheetInterface;
  language: Language;
}

const char_util = DandDCharacterUtilities.getInstance();

export default function CharacterLanguageCustomization({
  character,
  char_interface,
  language,
}: Props) {
  const obj_id = language._id;
  const [customization, setCustomization] = useState<{ id: string, proficiency: boolean | null, notes: string }>({ id: obj_id, proficiency: null, notes: "" });
  const [fetched, setFetched] = useState(false);

  // eslint-disable-next-line
  useEffect(() => {
    if (!fetched) {
      setFetched(true);
      // const parent = char_interface.non_skill_prof_customizations.Language;

      // if (parent) {
      //   const customization_maybe = parent.find(o => o.id === obj_id);
      //   if (customization_maybe) {
      //     setCustomization(customization_maybe);
      //   }
      // }
    }
  });
  
  // const prof = char_interface.languages_known.includes(obj_id);
  // return (
  //   <Grid container spacing={0} direction="row">
  //     <Grid
  //       className="vCentered"
  //       size={{
  //         xs: 4
  //       }}>
  //       { language.name }{ prof ? " (Known)" : "" }
  //     </Grid>
  //     <Grid
  //       size={{
  //         xs: customization.proficiency !== null ? 4 : 8
  //       }}>
  //       <SelectStringBox
  //         name="Known?"
  //         value={ customization.proficiency !== null ? (customization.proficiency ? "Known" : "Not Known") : "Not Custom" }
  //         options={["Not Custom", "Known", "Not Known"]}
  //         onChange={(changed: string) => {
  //           // if (changed === "Not Custom") {
  //           //   char_interface.non_skill_prof_customizations.Language = char_interface.non_skill_prof_customizations.Language.filter(o => o.id !== obj_id);
  //           //   setCustomization({ id: obj_id, proficiency: null, notes: "" });
  //           // } else {
  //           //   const new_prof = changed === "Known" ? true : false;
  //           //   if (!char_interface.non_skill_prof_customizations.Language) {
  //           //     char_interface.non_skill_prof_customizations.Language = [];
  //           //   }
  //           //   const cust = char_interface.non_skill_prof_customizations.Language.find(o => o.id === obj_id);
  //           //   if (cust) {
  //           //     cust.proficiency = new_prof;
  //           //     setCustomization({ id: obj_id, proficiency: new_prof, notes: customization.notes });
  //           //   } else {
  //           //     char_interface.non_skill_prof_customizations.Language.push({ id: obj_id, proficiency: new_prof, notes: "" });
  //           //     setCustomization({ id: obj_id, proficiency: new_prof, notes: "" });
  //           //   }
  //           // }
  //           // char_util.recalcLanguages(character);
  //           // character.changed();
  //           // character.subscription_holder.skillsChanged();
  //         }}
  //       />
  //     </Grid>
  //     { customization.proficiency !== null &&
  //       <Grid
  //         size={{
  //           xs: 4
  //         }}>
  //         <StringBox
  //           name={ `Source/Notes` }
  //           value={ customization.notes }
  //           onBlur={(changed: string) => {
  //             // const cust = char_interface.non_skill_prof_customizations.Language.find(o => o.id === obj_id);
  //             // if (cust) {
  //             //   cust.notes = changed;
  //             //   setCustomization({ id: obj_id, proficiency: customization.proficiency, notes: changed });
  //             // }
  //             // character.changed();
  //             // character.subscription_holder.skillsChanged();
  //           }}
  //         />
  //       </Grid>
  //     }
  //   </Grid>
  // );
  return <></>
}
